import React, { useState, useEffect } from 'react'
import axiosJWT from '../../secureAPI/axiosJWT';
import getUserData from '../../secureAPI/GetUserData';
import useNavigation from '../../common/useNavigation.js';
import useGetUserData from '../../secureAPI/GetUserData';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils.js';
import Navigations from '../../common/useNavigation.js';
import { sidebarLogo } from '../../common/common';
const MidPlans = (type) => {
    const { navigateDashboard } = Navigations();
    const { users , subUser } = useGetUserData();
    const [isAnnual, setIsAnnual] = useState(false);
    const [isINR, setIsINR] = useState(true);
    const [isDisabled, setisDisabled] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [userPlanDetails, setuserPlanDetails] = useState([]);
    const [Mainplans, setMainplans] = useState([]);
   ;
    
    useEffect(() => {
        //  console.log('called useeffectsss');
        if (Array.isArray(users) && users.length > 0) {
            // console.log('useEffect called, users:', users);
            logUserData();
        }
    }, [users]);

    const logUserData = () => {
        if (users?.length > 0) {
            if (users[0]['IsPersonalDetils'] === 1) {

            }
            else {

                navigateDashboard('seller');
            }

        }
    };
    useEffect(() => {
        fetchPlansData();
        fetchuserPlansData();
    }, []);

    const fetchPlansData = async () => {

        try {
            StartLoading(setisLoading, setisDisabled);
            const response = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetPlans`);
            if (response.data.success === 1 && Array.isArray(response.data.data)) {
                // const formattedPlans = response.data.data.map(plan => ({
                //     ...plan,
                //     features: plan.features.split(','),
                // }));
                setMainplans(response.data.data);
                // setMainplans(response.data.data);
            } else {

            }


        } catch (err) {
            console.error("Failed to load new orders, please try again later ", err);
        } finally {
            StopLoading(setisLoading, setisDisabled)
        }
        // await Promise.all([
        //     getNewOrders(),
        //     getConfirmOrders(),
        //     getOnHoldOrders(),
        //     getOnProcessOrders(),
        //     getCompletedOrders(),
        //     getCancelledOrders()
        // ]);

    };

    // Fetch all order data in one function to reduce repetition
    const fetchuserPlansData = async () => {

        try {
            StartLoading(setisLoading, setisDisabled);
            const response = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetUserPlansDetails`, {}, { withCredentials: true });
            // console.log(response.data);
            // setuserPlanDetails(response.data.data);
            if (response.data.success === 1 && Array.isArray(response.data.data)) {
                setuserPlanDetails(response.data.data);
            } else {

            }


        } catch (err) {
            console.error("Failed to load new orders, please try again later ", err);
        } finally {
            StopLoading(setisLoading, setisDisabled)
        }
        // await Promise.all([
        //     getNewOrders(),
        //     getConfirmOrders(),
        //     getOnHoldOrders(),
        //     getOnProcessOrders(),
        //     getCompletedOrders(),
        //     getCancelledOrders()
        // ]);

    };
    const getAmount = (plan) => {
        if (isINR) {
            return isAnnual ? plan.inrprice.yearly : plan.inrprice.monthly;
        }
        return isAnnual ? plan.price.yearly : plan.price.monthly;
    };


   
    const handlePayment = async (plan) => {
        function loadScript(src) {
            return new Promise((resolve) => {
                const script = document.createElement("script");
                script.src = src;
                script.onload = () => {
                    resolve(true);
                };
                script.onerror = () => {
                    resolve(false);
                };
                document.body.appendChild(script);
            });
        }
        const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
        if (!res) {
            // alert("Razorpay SDK failed to load. Are you online?");
            return;
        }

        var currency, yearly;
        // console.log({ plan: plan });
        if (isINR) {
            currency = 1;
        }
        else {
            currency = 2;
        }
        if (yearly) {
            yearly = 1;
        }
        else {
            yearly = 0;
        }
        const amount = getAmount(plan);
        const planName = plan.name;
        const data = { planName, amount, currency, yearly }
        // creating a new order
        // const result = await axiosJWT.post("http://localhost:5000/payment/orders");
        const result = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/CreatePlanOrder`, { data }, { withCredentials: true });
        // console.log({result:result});
        if (!result) {
            // alert("Server error. Are you online?");
            return;
        }

        // Getting the order details back
        // const { amount, id: order_id, currency } = result.data;
        const amounts = 1600;
        const order_id = 'ds5d4s4ds54ds5';
        const currencyString = 'INR';

        const options = {
            key: "rzp_test_HHHXi6bhZ0bIvf", // Enter the Key ID generated from the Dashboard
            amount: amounts.toString(),
            currency: currencyString,
            name: "Soumya Corp.",
            description: "Test Transaction",
            image: { sidebarLogo },
            order_id: order_id,
            handler: async function (response) {
                const data = {
                    orderCreationId: order_id,
                    razorpayPaymentId: response.razorpay_payment_id,
                    razorpayOrderId: response.razorpay_order_id,
                    razorpaySignature: response.razorpay_signature,
                };

                const result = await axiosJWT.post("http://localhost:5000/payment/success", data);

                // alert(result.data.msg);
            },
            prefill: {
                name: "Soumya Dey",
                email: "SoumyaDey@example.com",
                contact: "9999999999",
            },
            notes: {
                address: "Soumya Dey Corporate Office",
            },
            theme: {
                color: "#61dafb",
            },
        };

        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
    }
    return { users, isLoading, setisLoading, isAnnual, setIsAnnual, isINR, setIsINR, Mainplans, handlePayment, userPlanDetails , subUser }
}

export default MidPlans